export default __webpack_public_path__ + "static/media/icons-evidences.2b8c6d42.svg";